import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';
import { whatIfOptionsOrDefaultSelector, whatIfInnerSelector } from '../WhatIfsSelector';
import AssetAllocationChartDescriptor from './AssetAllocationChartDescriptor';

export const modelPortfoliosSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).ModelPortfolios;

export const detailedModelPortfoliosSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).DetailedModelPortfolios || [];

export const legendSelectorFunction = (modelPortfolios, portfolioId) => {
  const { ADV } = window;
  let legends = [];

  if (modelPortfolios) {
    let modelPortfolio = modelPortfolios.filter(item => item.Id === portfolioId);

    if (portfolioId && modelPortfolio.length === 0) {
      modelPortfolio = [modelPortfolios[0]];
    }

    legends = modelPortfolio.map(portfolio => {
      const parsedSeries = ADV.util.chart.parseAllocationSeries(portfolio.AssetClassChart);
      return parsedSeries.Labels;
    });
  }
  if (legends.length > 0) {
    return legends[0];
  }
  return [];
};

function renderPrettyChartSVG() {
  if (this.extraGroup) {
    this.extraGroup.destroy();
  }
  this.extraGroup = this.renderer
    .g()
    .attr({
      zIndex: -1,
      id: 'chart-pretty-svg',
    })
    .add();

  const bbox = this.renderer.boxWrapper.getBBox();
  // eslint-disable-next-line
  const middleX = bbox.x + bbox.width / 2;
  // eslint-disable-next-line
  const middleY = bbox.y + bbox.height / 2;

  this.renderer
    // eslint-disable-next-line
    .circle(middleX, middleY, bbox.width / 2 - 3)
    .attr({
      fill: '#1D1E20',
    })
    .add(this.extraGroup);

  this.renderer
    // eslint-disable-next-line
    .arc(middleX, middleY, bbox.width / 2, bbox.width / 2 - 3, 0, Math.PI)
    .attr({
      fill: '#FFFFFF',
      opacity: 0.14,
    })
    .add(this.extraGroup);
}

export const chartDataSelectorFunction = (modelPortfolios, portfolioId) => {
  const { ADV } = window;
  const hcParams = cloneDeep(AssetAllocationChartDescriptor);

  if (modelPortfolios && portfolioId) {
    const AllocationData = ADV.util.chart.parseAllocationSeries(
      (modelPortfolios.find(item => item.Id === portfolioId) || modelPortfolios[0]).AssetClassChart,
    );
    hcParams.tooltip.enabled = false;
    hcParams.series[0].data = AllocationData.Series;
    hcParams.series[0].animation = true;
  }
  hcParams.chart.events = {
    load: renderPrettyChartSVG,
    redraw: renderPrettyChartSVG,
  };
  return hcParams;
};

export const preRetirementPortfolioNameSelector = (state, props) =>
  whatIfInnerSelector(state, props).PreRetirementPortfolioName;

export const postRetirementPortfolioNameSelector = (state, props) =>
  whatIfInnerSelector(state, props).PostRetirementPortfolioName;

export const portfolioNameSelector = (state, props) =>
  whatIfInnerSelector(state, props).PortfolioName;

export const portfolioIdSelector = (state, props) => whatIfInnerSelector(state, props).PortfolioId;

export const preRetirementPortfolioIdSelector = (state, props) =>
  whatIfInnerSelector(state, props).PreRetirementPortfolioId;

export const postRetirementPortfolioIdSelector = (state, props) =>
  whatIfInnerSelector(state, props).PostRetirementPortfolioId;

export const modelPortfoliosOptionsSelector = createSelector(
  modelPortfoliosSelector,
  (modelPortfolios = []) => {
    return modelPortfolios.reduce((options, modelPortfolio) => {
      return [
        ...options,
        {
          label: modelPortfolio.Name,
          value: modelPortfolio.Id,
          groupId: modelPortfolio.GroupId || 'default',
        },
      ];
    }, []);
  },
);

export const preChartDataSelector = createSelector(
  modelPortfoliosSelector,
  preRetirementPortfolioIdSelector,
  chartDataSelectorFunction,
);

export const postChartDataSelector = createSelector(
  modelPortfoliosSelector,
  postRetirementPortfolioIdSelector,
  chartDataSelectorFunction,
);

export const preLegendSelector = createSelector(
  modelPortfoliosSelector,
  preRetirementPortfolioIdSelector,
  legendSelectorFunction,
);

export const postLegendSelector = createSelector(
  modelPortfoliosSelector,
  postRetirementPortfolioIdSelector,
  legendSelectorFunction,
);

export const chartDataSelector = createSelector(
  modelPortfoliosSelector,
  portfolioIdSelector,
  chartDataSelectorFunction,
);

export const legendSelector = createSelector(
  modelPortfoliosSelector,
  portfolioIdSelector,
  legendSelectorFunction,
);

export const modelPortfolioGroupsSelector = state => {
  const { WhatIfs } = state;
  return WhatIfs.modelPortfolioGroups;
};
